import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DeviceTypeService} from '../../device-type/device-type.service';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {PackageServiceService} from '../service/package-service.service';

@Component({
  selector: 'app-package-form',
  templateUrl: './package-form.component.html',
  styleUrls: ['./package-form.component.css']
})
export class PackageFormComponent implements OnInit {
  packageId: any;
  isEdit = false;
  packageDetailForm: FormGroup;
  secondFormGroup: FormGroup;
  deviceTypeList: any = [];
  loading: boolean;
  submitted: boolean;
  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private deviceTypeService: DeviceTypeService,
              private packageService: PackageServiceService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {

    this.route.fragment.subscribe(fragment => { this.packageId = fragment; });

    if (this.packageId) {
      this.isEdit = true;
      this.getPackageDetails(this.packageId);
    }

    this.packageDetailForm = this._formBuilder.group({
      id: [''],
      deviceTypeId: ['', Validators.required],
      serialNumber: ['', Validators.required],
      udid: ['', Validators.required],
      deviceMacId: ['', Validators.required],
      comment: ['']
    });
  }

  ngOnInit() {
    this.getAllDeviceTypes();
  }

  public  getPackageDetails(packaeId) {
    this.packageService.getPackageDetails(packaeId)
        .pipe(first())
        .subscribe(data => {
          const response = data.json();
          this.packageDetailForm.controls['deviceTypeId'].setValue( response.deviceTypeId);
          this.packageDetailForm.controls['serialNumber'].setValue( response.deviceSerialNumber);
          this.packageDetailForm.controls['udid'].setValue( response.udid);
          this.packageDetailForm.controls['deviceMacId'].setValue( response.deviceMacId);
          this.packageDetailForm.controls['id'].setValue( response.id);

        }, (error) => {
          this.toastr.error('', 'Please try again');
        });
  }


  public getAllDeviceTypes() {
    this.loading = true;
    this.deviceTypeService.getAllDeviceTypes()
        .subscribe(data => {
          if (data.status === 200) {
            const response: any = data.json();
            this.deviceTypeList = response.devicetypes;
            console.log(response.devicetypes);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  public savePackage(packageDetailForm: any) {
    this.loading = true;
    this.submitted = true;
    console.log(JSON.stringify(this.packageDetailForm.value));
    this.packageService.addUpdatePackage(packageDetailForm.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Package saved successfully');
            this.router.navigate(['/elasticcare/package']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }
}
